import { render, staticRenderFns } from "./ArticleManagementList.vue?vue&type=template&id=2930ab37&scoped=true&"
import script from "./ArticleManagementList.vue?vue&type=script&lang=js&"
export * from "./ArticleManagementList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManagementList.vue?vue&type=style&index=0&id=2930ab37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2930ab37",
  null
  
)

export default component.exports